// src/lib/opportunity/signedContractDocumentSlot.ts
//
// Recommended Documents-tab slot for signed/re-uploaded contract PDFs.
// Managers configure slots in Proposal formats; this constant is the
// convention the Generated tab's "Upload signed" action looks for.

export const SIGNED_CONTRACT_SLOT_KEY = "signed_contract";

export const SIGNED_CONTRACT_SLOT_LABEL = "Signed contract";

export const SIGNED_CONTRACT_SLOT_HELPER =
  "Customer-signed contract PDF after external signature (DocuSign, wet ink, etc.). Generated packages live under Generated documents — upload the signed file here.";

export const SIGNED_CONTRACT_DOCUMENT_TYPE = "Signed contract";
